module.exports = __webpack_public_path__ + "img/mobile-foreground.3e6da428.webp";